import { useLanguage } from "../LanguageProvider/LanguageProvider";

const SingleWindowPortalChart = () => {
  const { language } = useLanguage(); // true = Hindi, false = English

  const content = {
    heading: {
      title: {
        en: "Single Window Portal",
        hi: "सिंगल विंडो पोर्टल",
      },
      subTitle: {
        en: "Flow Chart",
        hi: "प्रक्रिया चार्ट",
      },
    },
    inPrinciple: {
      en: "In-Principle Approval (CAF)",
      hi: "सैद्धांतिक स्वीकृति (CAF)",
    },
    preEst: {
      en: "Pre Establishment Services (CTE)",
      hi: "स्थापना-पूर्व सेवाएं (CTE)",
    },
    preOp: {
      en: "Pre Operational Services (CTO)",
      hi: "संचालन-पूर्व सेवाएं (CTO)",
    },
    columns: [
      {
        title: {
          en: "Investor Login",
          hi: "निवेशक लॉगिन",
        },
        steps: [
          { en: "Investor Dashboard", hi: "निवेशक डैशबोर्ड" },
          {
            en: "In-principle Approval (CAF)",
            hi: "सैद्धांतिक स्वीकृति (CAF)",
          },
          {
            en: "New Unit or Expansion Unit",
            hi: "नया यूनिट या विस्तार यूनिट",
          },
          {
            en: "Apply for In-Principle Approval",
            hi: "सैद्धांतिक स्वीकृति के लिए आवेदन",
          },
          { en: "Fill Information", hi: "जानकारी भरें" },
          { en: "Upload Documents", hi: "दस्तावेज़ अपलोड करें" },
          { en: "Submit", hi: "सबमिट करें" },
        ],
      },
      {
        title: {
          en: "Investor Login",
          hi: "निवेशक लॉगिन",
        },
        steps: [
          { en: "Investor Dashboard", hi: "निवेशक डैशबोर्ड" },
          { en: "Departmental Services", hi: "विभागीय सेवाएं" },
          { en: "Pre Establishment (CTE)", hi: "स्थापना-पूर्व (CTE)" },
          { en: "Select Different Departments", hi: "विभिन्न विभाग चुनें" },
          {
            en: "Select Required Pre Establishment Services",
            hi: "आवश्यक स्थापना-पूर्व सेवाएं चुनें",
          },
          { en: "Fill Information", hi: "जानकारी भरें" },
          {
            en: "Upload Documents & Submit",
            hi: "दस्तावेज़ अपलोड कर सबमिट करें",
          },
        ],
      },
      {
        title: {
          en: "Investor Login",
          hi: "निवेशक लॉगिन",
        },
        steps: [
          { en: "Investor Dashboard", hi: "निवेशक डैशबोर्ड" },
          { en: "Departmental Services", hi: "विभागीय सेवाएं" },
          { en: "Pre Operational (CTO)", hi: "संचालन-पूर्व (CTO)" },
          { en: "Select Different Departments", hi: "विभिन्न विभाग चुनें" },
          {
            en: "Select Required Pre Operational Services",
            hi: "आवश्यक संचालन-पूर्व सेवाएं चुनें",
          },
          { en: "Fill Information", hi: "जानकारी भरें" },
          {
            en: "Upload Documents & Submit",
            hi: "दस्तावेज़ अपलोड कर सबमिट करें",
          },
        ],
      },
    ],
  };

  return (
    <div className="w-full flex flex-col items-center space-y-8 py-8">
      {/* Heading */}
      <div className="bg-white text-center py-6 px-8 rounded-xl w-full max-w-4xl shadow-lg">
        <h2 className="text-3xl font-bold text-theme-color">
          {language ? content.heading.title.hi : content.heading.title.en}
        </h2>
        <p className="text-lg mt-1 text-theme-color">
          {language ? content.heading.subTitle.hi : content.heading.subTitle.en}
        </p>
      </div>

      {/* URL Box */}
      <div className="bg-white py-3 px-6 rounded-lg shadow-md w-full max-w-4xl text-center font-semibold text-theme-color">
        https://investuttarakhand.uk.gov.in
      </div>

      {/* In-Principle Approval */}
      <div className="bg-white py-3 px-6 rounded-lg shadow-md w-full max-w-4xl text-center font-semibold text-theme-color ">
        {language ? content.inPrinciple.hi : content.inPrinciple.en}
      </div>

      {/* Two Services */}
      <div className="flex flex-col md:flex-row gap-6 w-full max-w-4xl justify-center">
        <div className="bg-white py-3 px-6 rounded-lg shadow-md text-center flex-1 font-semibold text-theme-color">
          {language ? content.preEst.hi : content.preEst.en}
        </div>
        <div className="bg-white py-3 px-6 rounded-lg shadow-md text-center flex-1 font-semibold text-theme-color">
          {language ? content.preOp.hi : content.preOp.en}
        </div>
      </div>

      {/* 3 Columns */}
      <div className="grid md:grid-cols-3 gap-6 w-full max-w-6xl">
        {content.columns.map((col, idx) => (
          <div
            key={idx}
            className="flex flex-col items-center space-y-3 bg-white shadow-lg px-6 py-4 rounded-xl"
          >
            <p className="bg-btn text-white px-5 py-2 rounded-full font-semibold">
              {language ? col.title.hi : col.title.en}
            </p>

            {col.steps.map((step, i) => (
              <p
                key={i}
                className="bg-gray-100 w-full text-center py-2 rounded-lg text-theme-color"
              >
                {language ? step.hi : step.en}
              </p>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SingleWindowPortalChart;
